import { WorkingScheduleDay, WorkingScheduleDaySlot } from "../services/menu/models";

// Рабочий день без слотов (так бэк создаёт демо-меню) — открыто весь день.
// toHour 24: moment переносит его на полночь следующих суток, так что сутки покрыты целиком.
const WHOLE_DAY_SLOT: WorkingScheduleDaySlot = { fromHour: 0, fromMinute: 0, toHour: 24, toMinute: 0 };

export const firstSlot = (day: WorkingScheduleDay): WorkingScheduleDaySlot =>
    day.slots[0] ?? WHOLE_DAY_SLOT;
